import { useContext, useEffect, useState } from "react";
import React from "react";
import noSelfie from "../../assets/noSelfie.svg";
import selfieDefaultImage from "../../assets/selfieDefaultImage.svg";
import uploadIcon from "../../assets/uploadIcon.svg";
import errorMsg from "../../assets/errorMsg.svg";
import cross from "../../assets/cross.svg";
import markedIcon from "../../assets/markedIcon.gif";
import noAttendance from "../../assets/noAttendance.svg";
import locationIcon from "../../assets/locationIcon.svg";
import beforeAttendance from "../../assets/beforeAttendance.svg";
import axios from "axios";
import { urlLinks } from "../../UrlLinks";
import Loader from "../../containers/Loader";
import { MyContext } from "../../context/Context";
import moment from "moment";
import gallery from "../../assets/gallery.svg";

const AttendanceModal = ({
  isSelfieRequired,
  shiftStartTime,
  shiftEndTime,
  userId,
  projectId,
  attendancePageVisible,
  geo_fencing,
  radius,
  accessErr,
  setAccessErr,
  ...props
}) => {
  const { loading, setLoading } = useContext(MyContext);
  const [shiftType, setShiftType] = useState("");
  const [photo, setPhoto] = useState("");
  const [photoFile, setPhotoFile] = useState({});
  const [photoFilled, setPhotoFilled] = useState();
  const [markedResponse, setMarkedResponse] = useState({
    address: "",
    time: "",
    checkType: "",
  });
  const [beforeAttendanceTime, setBeforeAttendanceTime] = useState({
    time: "",
  });
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [location, setLocation] = useState("");
  const [hubLatitude, setHubLatitude] = useState("");
  const [hubLongitude, setHubLongitude] = useState("");
  const [attributes, setAttributes] = useState([]);

  // Function to check if user is within the specified radius
  const isUserWithinRadius = (
    userLat,
    userLong,
    hubLat,
    hubLong,
    radiusInMeters
  ) => {
    const toRadians = (degrees) => degrees * (Math.PI / 180);
    const R = 6371000; // Earth's radius in meters

    const lat1 = toRadians(userLat);
    const lat2 = toRadians(hubLat);
    const deltaLat = toRadians(hubLat - userLat);
    const deltaLong = toRadians(hubLong - userLong);

    const a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.sin(deltaLong / 2) *
        Math.sin(deltaLong / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in meters

    console.log("Calculated distance:", distance, "meters");
    console.log("Allowed radius:", radiusInMeters, "meters");
    console.log("Is within radius:", distance <= radiusInMeters);

    return distance <= radiusInMeters;
  };

  const getLocation = () => {
    console.log("getLocation");
    if (navigator.geolocation) {
      // Check permission status if Permissions API is available
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then((result) => {
            console.log("Geolocation permission status:", result.state);
            if (result.state === "denied") {
              setAccessErr(
                "Location access is denied. Please enable location permissions in your browser settings and refresh the page."
              );
              return;
            }
            requestLocation();
          })
          .catch(() => {
            // Permissions API not fully supported, proceed with request
            requestLocation();
          });
      } else {
        // Permissions API not available, proceed with request
        requestLocation();
      }
    } else {
      console.error("Geolocation is not supported by this browser.");
      setAccessErr(
        "Geolocation is not supported by your browser. Please use a modern browser to mark attendance."
      );
    }

    function requestLocation() {
      const options = {
        enableHighAccuracy: true,
        timeout: 15000, // Increased timeout
        maximumAge: 0, // Force fresh location
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Success: Set latitude, longitude, and location
          const { latitude, longitude } = position.coords;
          setLat(latitude);
          setLong(longitude);
          setAccessErr(""); // Clear any previous errors

          fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDRrgpIKVvHejEg-_1G0fy-JUXidaPi9vU`
          )
            .then((response) => response.json())
            .then((data) => {
              if (data && data.plus_code && data.plus_code.compound_code) {
                setLocation(data.plus_code.compound_code);
              } else {
                setLocation("");
                console.log("Not given location");
              }
            })
            .catch(() => setLocation(""));
        },
        (error) => {
          console.error("Geolocation error:", error);
          let errorMessage = "";
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage =
                "Location access denied. Please enable location permissions in your browser settings and refresh the page.";
              setAccessErr(
                "This page has been blocked from accessing your location. Please enable location permissions in your browser settings and refresh the page to mark attendance."
              );
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = "Location information is unavailable.";
              setAccessErr("Location information is unavailable. Please check your device settings.");
              break;
            case error.TIMEOUT:
              errorMessage = "Location request timed out. Please try again.";
              setAccessErr("Location request timed out. Please try again.");
              break;
            default:
              errorMessage = "An unknown error occurred while getting location.";
              setAccessErr("Unable to get your location. Please try again.");
              break;
          }
          console.error(errorMessage, "------------------");
          setLocation("");
        },
        options
      );
    }
  };

  const requestCameraAccess = () => {
    setAccessErr(""); // Clear any previous error message

    // Check if the browser supports the media devices API
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: true }) // Request camera access
        .then((stream) => {
          stream.getTracks().forEach((track) => track.stop()); // Stop the video stream
          // setCameraAllowed(true); // Set camera allowed to true
          setAccessErr(""); // Clear any error message
        })
        .catch((error) => {
          // setCameraAllowed(false); // Set camera allowed to false
          setAccessErr(
            "This page has been blocked from accessing your camera. Please unblock your camera access to click a selfie."
          );
        });
    }
  };

  function getCurrentTime() {
    const formattedTime = moment().format("HH:mm:ss");
    return formattedTime;
  }

  const day = moment().format("MMMM D");

  const formatTimeTo12Hour = (timeString) => {
    if (typeof timeString === "string" && timeString.includes(":")) {
      const formattedTimeTo12Hour = moment(timeString, "HH:mm:ss").format(
        "h:mm A"
      );

      return formattedTimeTo12Hour;
    }
  };

  const convertTimeToSeconds = (timeString) => {
    if (typeof timeString === "string" && timeString.includes(":")) {
      // Parse the time string into a moment duration
      const duration = moment.duration(timeString);

      // Convert to total seconds
      const totalSeconds = duration.asSeconds();

      return totalSeconds; // Convert to total seconds, handle missing seconds
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPhotoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhoto(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const saveAttendance = async () => {
    console.log("geo_fencing:", geo_fencing);
    console.log("hubLatitude:", hubLatitude);
    console.log("hubLongitude:", hubLongitude);
    console.log("User lat:", lat);
    console.log("User long:", long);
    console.log("Radius:", radius);
    
    setLoading(true);
    setAccessErr("");
    if (!lat || !long || !location) {
      setAccessErr(
        "This page has been blocked from accessing your location. Please unblock your location access to mark attendance."
      );
      setLoading(false);
      return;
    }

    if (geo_fencing) {
      if (hubLatitude && hubLongitude) {
        const withinRadius = isUserWithinRadius(
          lat,
          long,
          hubLatitude,
          hubLongitude,
          radius
        );
        console.log("withinRadius:", withinRadius);
        if (!withinRadius) {
          setAccessErr(
            "You are not inside the location perimeter. Please get inside to mark attendance"
          );
          setLoading(false);
          return;
        }
      }
    }

    const formData = new FormData();
    if (shiftType === "Start Shift") {
      formData.append("attendanceType", "0");
    } else if (shiftType === "End Shift") {
      formData.append("attendanceType", "1");
    }

    formData.append("projectId", projectId);
    formData.append("source", "1");
    formData.append("userId", userId);
    formData.append("latitude", lat);
    formData.append("longitude", long);
    formData.append("location", location);
    

    // Conditionally append file if required
    if (isSelfieRequired && photoFile) {
      formData.append("file", photoFile);
    }

    let list = [];
    attributes.map((attribute) => {
      list.push({
        attributeId: attribute.id,
        responseText:
          attribute.attributeType === "dropdown"
            ? attribute.dropdownAns
            : attribute.attributeType === "free_text"
            ? attribute.freeTextAns
            : null,
        images:
          attribute.attributeType === "multiple_image"
            ? attribute.imageUrls
            : attribute.attributeType === "single_image"
            ? [attribute.imageUrl]
            : [],
      });
    });

    formData.append("userResponse", JSON.stringify(list));

    try {
      const response = await axios.post(
        `${urlLinks.baseUrl}/${urlLinks.saveWorkerAttendance}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.code === 1000) {
        setLoading(false);
        const currentTime = getCurrentTime();
        const formattedTime = formatTimeTo12Hour(currentTime);
        // console.log(formattedTime)
        setMarkedResponse({
          address: location,
          time: formattedTime,
          checkType: shiftType === "Start Shift" ? "In Time" : "Out Time",
        });
        setShiftType("Marked");
        setPhoto("");
      }

      console.log("Success:", response.data);
    } catch (error) {
      console.error("Error during the API call:", error);
      setLoading(false);
    }
  };

  const checkIfAttendanceMarked = async () => {
    const currentDate = moment().format("YYYY-MM-DD");
    const currentTime = moment().format("HH:mm:ss");
    const currentSeconds = convertTimeToSeconds(currentTime);
    const startSeconds = convertTimeToSeconds(shiftStartTime);
    const endSeconds = convertTimeToSeconds(shiftEndTime);

    if (currentSeconds >= startSeconds) {
      if (projectId !== -1) {
        try {
          const response = await axios.get(
            `${urlLinks.baseUrl}/${urlLinks.attendanceHistory}?markedFrom=${currentDate}&markedTo=${currentDate}&projectId=${projectId}&userId=${userId}&rows=1&paging=2`
          );
          const attendanceRes = response.data.response;
          if (attendanceRes) {
            setHubLatitude(attendanceRes.hubLatitude);
            setHubLongitude(attendanceRes.hubLongitude);
            if (attendanceRes.attendanceDetails.length === 0) {
              setShiftType("Start Shift");
              let list = [];
              attendanceRes.checkinAttributes.map((attribute, index) => {
                list.push({
                  id: attribute.id,
                  attributeName: attribute.attributeName,
                  attributeType: attribute.attributeType,
                  isRequired: attribute.isRequired === 1 ? true : false,
                  ...(attribute.attributeType === "dropdown" && {
                    dropdownOptions: attribute.dropdownOptions,
                    dropdownAns: "",
                    dropdownAnsIdx: "",
                  }),
                  ...(attribute.attributeType === "single_image" && {
                    imageUrl: "",
                  }),
                  ...(attribute.attributeType === "multiple_image" && {
                    imageUrls: [],
                  }),
                  ...(attribute.attributeType === "free_text" && {
                    freeTextAns: "",
                  }),
                });
              });
              setAttributes(list);
            } else if (attendanceRes.attendanceDetails[0].checkinTime) {
              if (currentSeconds >= endSeconds) {
                if (attendanceRes.attendanceDetails[0].checkoutTime === null) {
                  setShiftType("End Shift");
                  let list = [];
                  attendanceRes.checkoutAttributes.map((attribute, index) => {
                    list.push({
                      id: attribute.id,
                      attributeName: attribute.attributeName,
                      attributeType: attribute.attributeType,
                      isRequired: attribute.isRequired === 1 ? true : false,
                      ...(attribute.attributeType === "dropdown" && {
                        dropdownOptions: attribute.dropdownOptions,
                        dropdownAns: "",
                        dropdownAnsIdx: "",
                      }),
                      ...(attribute.attributeType === "single_image" && {
                        imageUrl: "",
                      }),
                      ...(attribute.attributeType === "multiple_image" && {
                        imageUrls: [],
                      }),
                      ...(attribute.attributeType === "free_text" && {
                        freeTextAns: "",
                      }),
                    });
                  });
                  setAttributes(list);
                } else if (
                  attendanceRes.attendanceDetails[0].checkoutTime !== null
                ) {
                  const formatedTime = formatTimeTo12Hour(
                    attendanceRes.attendanceDetails[0].checkoutTime
                  );
                  setMarkedResponse({
                    address:
                      attendanceRes.attendanceDetails[0].checkoutLocation,
                    time: formatedTime,
                    checkType: "Out Time",
                  });
                  setShiftType("Marked");
                }
              } else {
                const Marktime = formatTimeTo12Hour(
                  attendanceRes.attendanceDetails[0].checkinTime
                );
                setMarkedResponse({
                  time: Marktime,
                  address: attendanceRes.attendanceDetails[0].checkinLocation,
                  checkType: "In Time",
                });
                setShiftType("Marked");
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      const formattedTime = formatTimeTo12Hour(shiftStartTime);

      if (formattedTime) {
        setBeforeAttendanceTime((prev) => ({
          ...prev,
          time: formattedTime, // Use formatted time
        }));
        setShiftType("Before Attendance");
        // console.log(formattedTime)
      }
    }
  };

  const handleDropdownClick = (attributeId, optionIndex) => {
    if (
      optionIndex ===
      attributes.find((attribute) => attribute.id === attributeId)
        .dropdownAnsIdx
    ) {
      setAttributes((prev) =>
        prev.map((attribute) =>
          attribute.id === attributeId
            ? { ...attribute, dropdownAns: "", dropdownAnsIdx: "" }
            : attribute
        )
      );
    } else {
      setAttributes((prev) =>
        prev.map((attribute) =>
          attribute.id === attributeId
            ? {
                ...attribute,
                dropdownAns: attributes.find(
                  (attribute) => attribute.id === attributeId
                ).dropdownOptions[optionIndex],
                dropdownAnsIdx: optionIndex,
              }
            : attribute
        )
      );
    }
  };

  const handleFreeTextChange = (attributeId, value) => {
    setAttributes((prev) =>
      prev.map((attribute) =>
        attribute.id === attributeId
          ? { ...attribute, freeTextAns: value }
          : attribute
      )
    );
  };

  const handleAttributeImageUpload = (attributeId, event) => {
    let file = null;
    if (event) {
      file = event.target.files[0];
    }
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAttributes((prev) =>
          prev.map((attribute) =>
            attribute.id === attributeId
              ? { ...attribute, imageUrl: reader.result }
              : attribute
          )
        );
      };
      reader.readAsDataURL(file);
    }
    if (event === "null") {
      setAttributes((prev) =>
        prev.map((attribute) =>
          attribute.id === attributeId
            ? { ...attribute, imageUrl: "" }
            : attribute
        )
      );
    }
  };

  const handleMultipleImageUpload = (attributeId, event) => {
    let file = null;
    if (event) {
      file = event.target.files[0];
    }
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAttributes((prev) =>
          prev.map((attribute) =>
            attribute.id === attributeId
              ? {
                  ...attribute,
                  imageUrls: [...attribute.imageUrls, reader.result],
                }
              : attribute
          )
        );
      };
      reader.readAsDataURL(file);
    }
    if (event === "null") {
      setAttributes((prev) =>
        prev.map((attribute) =>
          attribute.id === attributeId
            ? { ...attribute, imageUrls: [] }
            : attribute
        )
      );
    }
  };

  const validateRequiredAttributes = () => {
    return attributes.every((attribute) => {
      // If attribute is not required, skip validation
      if (!attribute.isRequired) {
        return true;
      }

      // Validate based on attribute type
      switch (attribute.attributeType) {
        case "dropdown":
          return attribute.dropdownAns && attribute.dropdownAns.trim() !== "";
        case "free_text":
          return attribute.freeTextAns && attribute.freeTextAns.trim() !== "";
        case "single_image":
          return attribute.imageUrl && attribute.imageUrl !== "";
        case "multiple_image":
          return attribute.imageUrls && attribute.imageUrls.length > 0;
        default:
          return true;
      }
    });
  };

  useEffect(() => {
    if (attendancePageVisible) {
      checkIfAttendanceMarked();
    } else {
      if (projectId !== -1) setShiftType("Not Alloted");
    }
  }, [shiftStartTime, shiftEndTime, projectId, userId, attendancePageVisible]);

  useEffect(() => {
    setPhoto("");
    getLocation();
  }, [projectId]);

  useEffect(() => {
    if (photo) {
      setPhotoFilled(true);
      if (
        accessErr ===
        "This page has been blocked from accessing your camera. Please unblock your camera access to click a selfie."
      ) {
        setAccessErr("");
      }
    } else {
      setPhotoFilled(false);
    }
  }, [photo]);

  useEffect(() => {
    if (isSelfieRequired) {
      requestCameraAccess();
    }
  }, [isSelfieRequired]);

  if (shiftType === "Start Shift" || shiftType === "End Shift") {
    return (
      <section className="w-full flex flex-col gap-4">
        <section className="w-full rounded-2xl bg-white border-[0.5px] border-[#E1E1E1] p-4">
          <div className="flex items-center justify-between">
            <div className="text-[16px] text-[#2e2e2e] font-medium">
              Today, {day}
            </div>
            <div className="bg-[#F0F8FF] text-[12px]  p-2 rounded-full text-[#1C75BC] font-medium">
              {shiftType}
            </div>
          </div>
          {isSelfieRequired ? (
            <section className="w-full flex flex-col items-center">
              <div className="relative overflow-hidden rounded-full w-[104px] h-[104px] mt-7">
                <img
                  src={photo || selfieDefaultImage}
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="border border-[#1C75BC] w-fit p-2 rounded-full mt-5 mb-7">
                <label htmlFor="fileInput" className="flex items-center gap-2">
                  <input
                    type="file"
                    accept="image/*"
                    capture="user" // Opens the front-facing camera by default
                    id="fileInput"
                    onChange={handleImageUpload}
                    className="hidden"
                  />
                  <img src={uploadIcon} alt="Upload Icon" className="w-4 h-4" />
                  <div className="text-[14px] text-[#1C75BC]">Click Selfie</div>
                </label>
              </div>
              {accessErr && (
                <div className="text-red-500 flex items-start gap-1 ">
                  <div className="mt-[3px] w-3 h-3 flex-shrink-0">
                    <img
                      src={errorMsg}
                      className="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                  <div className="text-xs mb-4">{accessErr}</div>
                </div>
              )}

              {/* <Swiper
              isSelfieFilled={photoFilled}
              setShiftType={setShiftType}
              setMarkedResponse={setMarkedResponse}
            /> */}
            </section>
          ) : (
            <section className="w-full flex flex-col gap-9 items-center justify-center pt-9">
              <div>
                <img src={noSelfie} alt="" />
              </div>
              {/* <Swiper
              isSelfieFilled={null}
              setShiftType={setShiftType}
              setMarkedResponse={setMarkedResponse}
            /> */}
              {accessErr && (
                <div className="text-red-500 flex items-start gap-1 -mb-7">
                  <div className="mt-[3px] w-3 h-3 flex-shrink-0">
                    <img
                      src={errorMsg}
                      className="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                  <div className="text-xs mb-4">{accessErr}</div>
                </div>
              )}
              <div
                onClick={() => {
                  if (!loading && validateRequiredAttributes())
                    saveAttendance();
                }}
                className={`text-white text-xl font-semibold text-center ${
                  !loading && validateRequiredAttributes()
                    ? "bg-[#1C75BC]"
                    : "bg-gray-300 cursor-not-allowed"
                } p-2 w-full rounded-xl cursor-pointer`}
              >
                {!loading ? "Mark Attendance" : "Marking..."}
              </div>
            </section>
          )}
        </section>

        {attributes.length
          ? attributes.map((attribute, index) => (
              <section
                key={attribute.id}
                className="w-full rounded-2xl bg-white border-[#E1E1E1] p-4"
              >
                <div className="flex items-start gap-2 mb-3">
                  {" "}
                  <div className="text-[14px] text-[#2e2e2e] font-medium">
                    Q{index + 1}.
                  </div>
                  <div className="text-[14px] text-[#2e2e2e] font-medium">
                    {attribute.attributeName}{" "}
                    {attribute.isRequired ? (
                      <span className="text-red-500">*</span>
                    ) : null}
                  </div>{" "}
                </div>
                {attribute.attributeType === "dropdown" && (
                  <div className="flex justify-between flex-wrap gap-[10px] ">
                    {attribute.dropdownOptions.map((option, index) => (
                      <div className="flex gap-2  w-[45%]">
                        <div
                          onClick={() =>
                            handleDropdownClick(attribute.id, index)
                          }
                          className={`w-3 h-3 cursor-pointer rounded-full border  flex-shrink-0 mt-1 p-0.5 ${
                            attribute.dropdownAnsIdx === index
                              ? "border-[#1C75BC]"
                              : "border-gray-400"
                          }`}
                        >
                          <div
                            className={`w-full h-full rounded-full ${
                              attribute.dropdownAnsIdx === index
                                ? "bg-[#1C75BC]"
                                : ""
                            }`}
                          ></div>
                        </div>
                        <div
                          key={index}
                          className="text-[14px] w-full text-[#2e2e2e] break-words"
                        >
                          {option}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {attribute.attributeType === "free_text" && (
                  <textarea
                    value={attribute.freeTextAns}
                    onChange={(e) => {
                      if (e.target.value.length < 300) {
                        handleFreeTextChange(attribute.id, e.target.value);
                      } else {
                        return;
                      }
                    }}
                    className="w-full h-24 bg-[#F8F8F8] rounded-[12px] focus:outline-none text-[#2e2e2e] text-[14px] p-2 resize-none placeholder:text-[#757575]"
                    placeholder="Write your response....."
                  />
                )}
                {attribute.attributeType === "single_image" && (
                  <div className="w-full mb">
                    {!attribute.imageUrl && (
                      <div
                        // htmlFor={`imageInput-${attribute.id}`}
                        className="w-full border border-[#1C4980] border-dashed rounded-[12px] py-4 flex flex-col items-center justify-center cursor-pointer gap-2"
                      >
                        <img
                          src={gallery}
                          alt="Upload Icon"
                          className="w-7 h-7 object-contain my-2"
                        />
                        <div className="text-[14px] text-[#2e2e2e] font-semibold">
                          Choose a file from your folder
                        </div>
                        <div className="text-[12px] text-[#757575] font-medium">
                          JPEG, PNG & JPG formats only
                        </div>
                        <label
                          htmlFor={`imageInput-${attribute.id}`}
                          className="border border-[#1C4980] rounded-[12px] px-3 py-2 text-[14px] text-[#1C4980] font-semibold cursor-pointer"
                        >
                          Browse File
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          capture="environment"
                          id={`imageInput-${attribute.id}`}
                          onChange={(e) =>
                            handleAttributeImageUpload(attribute.id, e)
                          }
                          className="hidden"
                        />
                      </div>
                    )}
                    {attribute.imageUrl ? (
                      <div className="relative w-16 h-16 rounded-[5px] overflow-hidden mb-3 transition-all duration-300">
                        <img
                          src={attribute.imageUrl}
                          alt="Uploaded"
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute top-2 right-1">
                          <img
                            src={cross}
                            alt="Cross"
                            className="w-4 h-4 cursor-pointer bg-black rounded-full"
                            onClick={() =>
                              setAttributes((prev) =>
                                prev.map((attribute1) =>
                                  attribute1.id === attribute.id
                                    ? { ...attribute1, imageUrl: "" }
                                    : attribute1
                                )
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
                {attribute.attributeType === "multiple_image" && (
                  <div className="w-full">
                    {attribute.imageUrls.length < 5 && (
                      <div
                        className={`w-full border border-[#1C4980] border-dashed rounded-[12px] py-4 flex flex-col items-center justify-center cursor-pointer gap-2`}
                      >
                        <img
                          src={gallery}
                          alt="Upload Icon"
                          className="w-7 h-7 object-contain my-2"
                        />
                        <div className="text-[14px] text-[#2e2e2e] font-semibold">
                          Choose a file from your folder
                        </div>
                        <div className="text-[12px] text-[#757575] font-medium">
                          JPEG, PNG & JPG formats only
                        </div>
                        <label
                          htmlFor={`imageInput-${attribute.id}`}
                          className="border border-[#1C4980] rounded-[12px] px-3 py-2 text-[14px] text-[#1C4980] font-semibold cursor-pointer"
                        >
                          Browse File
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          capture="environment"
                          id={`imageInput-${attribute.id}`}
                          onChange={(e) =>
                            handleMultipleImageUpload(attribute.id, e)
                          }
                          className="hidden"
                        />
                      </div>
                    )}
                    {attribute.imageUrls && attribute.imageUrls.length > 0 && (
                      <div className="flex flex-wrap gap-4 mt-5">
                        {attribute.imageUrls.map((imageUrl, indexUrl) => (
                          <div
                            key={indexUrl}
                            className="relative w-16 h-16 rounded-[5px] overflow-hidden"
                          >
                            <img
                              src={imageUrl}
                              alt="Uploaded"
                              className="w-full h-full object-cover"
                            />
                            <div className="absolute top-2 right-1 w-4 h-4 bg-black flex items-center justify-center rounded-full">
                              <img
                                src={cross}
                                alt="Cross"
                                className="w-10 h-10 cursor-pointer "
                                onClick={() =>
                                  setAttributes((prev) =>
                                    prev.map((attribute1, idx) =>
                                      idx !== index
                                        ? attribute1
                                        : {
                                            ...attribute1,
                                            imageUrls:
                                              attribute1.imageUrls.filter(
                                                (imageUrl, idx1) =>
                                                  idx1 !== indexUrl
                                              ),
                                          }
                                    )
                                  )
                                }
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </section>
            ))
          : null}
        <div className="w-full bg-white py-2">
          <div
            onClick={() => {
              if (photoFilled && !loading && validateRequiredAttributes())
                saveAttendance();
            }}
            className={`text-white text-xl font-semibold text-center p-2 w-full rounded-xl cursor-pointer ${
              photoFilled && !loading && validateRequiredAttributes()
                ? "bg-[#1C75BC]"
                : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            {loading ? "Marking..." : "Mark Attendance"}
          </div>
        </div>
      </section>
    );
  } else if (shiftType === "Marked") {
    return (
      <section className="w-full bg-white rounded-2xl border border-[#E1E1E1] p-4">
        <div className="flex items-center justify-between">
          <div className="text-[16px] text-[#2e2e2e] font-medium">
            Today, {day}
          </div>
        </div>
        <div className="w-full flex justify-center p-8 pb-6">
          <div className="w-14 h-14 ">
            <img src={markedIcon} alt="" />
          </div>
        </div>
        <div className="font-semibold text-lg flex justify-center text-[#2e2e2e]">
          Attendance Marked
        </div>
        <div className="grid grid-cols-3 pt-7">
          <div className="flex flex-col gap-[5px] justify-center items-center border-r border-gray-200">
            <div className="text-sm text-[#2e2e2e] font-medium">
              {markedResponse && markedResponse.time}
            </div>
            <div className="text-xs text-[#757575]">{markedResponse && markedResponse.checkType}</div>
          </div>
          <div className="col-span-2 flex  px-3 gap-1 items-start">
            <div className="w-4 h-4 mt-[3px] flex-shrink-0">
              {" "}
              {/* Fix width and height */}
              <img
                src={locationIcon}
                alt="location-icon"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="text-[12px]">
              {markedResponse && markedResponse.address}
            </div>
          </div>
        </div>
      </section>
    );
  } else if (shiftType === "Before Attendance") {
    return (
      <section className="w-full bg-white rounded-2xl border border-[#E1E1E1] p-4">
        <div className="flex flex-col justify-center items-center gap-4">
          <div className="w-40 h-40">
            <img src={beforeAttendance} alt="before-attendance-icon" />
          </div>
          <div className="text-lg font-semibold text-center">
            You will be able to mark your attendance after{" "}
            {beforeAttendanceTime.time}
          </div>
          <div className="text-sm text-[#757575] font-light text-center px-6">
            Please make sure you reach the location before{" "}
            {beforeAttendanceTime.time}
          </div>
          <div className="text-white text-xl font-semibold text-center bg-gray-300 cursor-not-allowed p-2 w-full rounded-xl">
            {!loading ? "Mark Attendance" : "Marking..."}
          </div>
        </div>
      </section>
    );
  } else if (shiftType === "Not Alloted") {
    return (
      <section className="w-full bg-white rounded-2xl border border-[#E1E1E1] p-4">
        <div className="flex items-center pb-4">
          <div className="text-[16px] text-[#2e2e2e] font-medium">
            Today, {day}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-2 pt-4">
          {/* <div className="flex justify-center items-center bg-[#E3F3FF] rounded-full w-16 h-16 p-2"> */}
          <div className="w-16 h-16 ">
            <img src={noAttendance} alt="" />
          </div>
          {/* </div> */}
          <div className="font-semibold text-base text-center text-[#2e2e2e] pt-4">
            No Attendance marking required for today
          </div>
          <div className="text-sm text-[#757575] font-light text-center px-6 pb-4">
            You can mark attendance only on your workdays. A reminder will
            notify you when it's time
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <div className="w-full flex justify-center items-center p-16">
        <Loader />
      </div>
    );
  }
};

export default AttendanceModal;
